import { Box } from '@mui/material';
import * as React from 'react';

export default function Footer()
{
    return (
        <Box bgcolor="secondary.main" color="primary.contrastText" width="100%" textAlign="center" p={5} mt={3}>
            Direct Validation Services Limited
            <br />
            {window.__appSettings.applicationVersion} {window.__appSettings.applicationCopyright}
        </Box>
    )
}
